import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

import { EmployeeCostCenter } from '../employee';

export type EmployeeHistoryType = {
  fEmpCostCenters?: EmployeeCostCenter[];
  fEmpJobTitle: string;
  fEmpLegalEntity: number;
  fEmpUnitPositions: [];
  fInternalPositionAttachmentId: number;
  fInternalPositionAttachmentName: string;
  fInternalPositionEmpId: number;
  fInternalPositionEndDate: string;
  fInternalPositionEnteredTime: string;
  fInternalPositionId: number;
  fInternalPositionIncludeInOverallExperience: boolean;
  fInternalPositionInfo: string;
  fInternalPositionIsCurrent: boolean;
  fInternalPositionIsPending: boolean;
  fInternalPositionManager: number;
  fInternalPositionPosition: string;
  fInternalPositionStartDate: string;
  fInternalPositionSupersededTime: string;
  fInternalPositionUnit: number;
};

export const getEmployeeHistory = (
  id: string,
  period: string = 'historical',
): Promise<EmployeeHistoryType[]> => {
  return fetchFromOldApi(
    '/json/employee/' + id + '/dev/pos/internal?period=' + period,
  ).then((r) => r.json());
};

type PropsType = {
  employeeId: number;
  period?: string;
};
export const useEmployeeHistory = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { employeeId, period } = props;

  const { data, isLoading, error } = useArraySWR<EmployeeHistoryType>(
    !!employeeId && !isDisabled ? ['getEmployeeHistory', employeeId] : null,
    () => getEmployeeHistory(String(employeeId), period),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
